import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import RetentionFormComponent from '../../finance/retention/RetentionFormComponent';

export default function ContractRetentionTemplates({value = [], onChange, t, readOnly = false, saving = false, currency}) {
  const [categories, setCategories] = useState([]);
  const [editor, setEditor] = useState(null);
  useEffect(() => {
    let active = true;
    const headers = {'Authorization': 'Bearer ' + localStorage.getItem('userToken'), 'App-Network': localStorage.getItem('networkId')};
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/retention-category?rows=9999', {headers})
      .then(response => { if (active) setCategories(response.data.data.items || []); })
      .catch(error => { if (active) window.App.toastShow('error', t('error'), error.toString(), '', error.response); });
    return () => { active = false; };
  }, [t]);

  const save = async row => {
    const next = editor.index === null ? [...value, row] : value.map((item, index) => index === editor.index ? row : item);
    if (await onChange(next)) setEditor(null);
  };
  const open = (row = {}, index = null) => setEditor({index, value: {
    retention_category: row.retentionCategory, percentage: row.percentage, amount: row.amount,
    vat_rate: row.vatRate, release_date: row.releaseDate ? new Date(row.releaseDate) : null, note: row.note || '',
  }});
  return <div className="p-col-12">
    <h3>{t('contractRetentionTemplates')}</h3>
    {!readOnly && <Button type="button" icon="pi pi-plus" label={t('addRetention')} disabled={saving} className="p-mb-3" onClick={() => open()}/>}
    <DataTable value={value} loading={saving} emptyMessage={t('noResults')} stripedRows responsiveLayout="scroll">
      <Column header={t('fieldCategory')} body={row => categories.find(item => Number(item.id) === Number(row.retentionCategory))?.name || '—'}/>
      <Column header={t('fieldAmount')} body={row => row.percentage != null ? row.percentage + '%' : window.App.currencyFormatter(currency || 'HUF', row.amount)}/>
      <Column header={t('columnRetentionExpiryDate')} body={row => row.releaseDate ? window.App.formatDateValue(row.releaseDate) : '—'}/>
      <Column field="note" header={t('columnComment')}/>
      {!readOnly && <Column body={(row, options) => <>
        <Button icon="pi pi-pencil" className="p-button-warning p-mr-2" tooltip={t('edit')} disabled={saving} onClick={() => open(row, options.rowIndex)}/>
        <Button icon="pi pi-trash" className="p-button-danger" tooltip={t('delete')} disabled={saving} onClick={() => {
          if (window.confirm('A törlés megerősítésére van szükség!')) onChange(value.filter((_, index) => index !== options.rowIndex));
        }}/>
      </>} className="p-text-right p-text-nowrap"/>}
    </DataTable>
    <Dialog header={t(editor?.index === null ? 'addRetention' : 'edit')} visible={editor !== null} modal
      style={{width: '760px', maxWidth: '95vw'}} closable={!saving} closeOnEscape={!saving} onHide={() => { if (!saving) setEditor(null); }}>
      {editor && <RetentionFormComponent templateMode templateValue={editor.value} onTemplateSubmit={save} saving={saving}/>}
    </Dialog>
  </div>;
}
